import createGetFormMeta from '../selectors/getFormMeta';
import immutable from '../structure/immutable';

export default createGetFormMeta(immutable);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/immutable/getFormMeta.js
// module id = 1197
// module chunks = 0